import React from 'react';

const EntryLayout = () => {
  return <div>EntryLayout</div>;
};

export default EntryLayout;
